import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {
    DcPageContentComponent
} from "../component/protected-components/dc-page-content-component/dc-page-content.component";
import {
    DcPageHierarchyTreeComponent
} from "../component/protected-components/dc-page-hierarchy-tree-component/dc-page-hierarchy-tree.component";
import {
    DcPageSearchComponent
} from "../component/protected-components/dc-page-search-component/dc-page-search.component";
import {DcDocsPage} from "../page/overview/dc-config/dc-docs.page";


const dcModuleEntry: TestModuleDefinition = {
    key: 'dc',
    label: 'Documentation (dc)',
    components: [
        {
            key: 'DcPageContentComponent',
            component: DcPageContentComponent,
            selector: 'dc-page-content',
            type: 'Component',
            label: 'dc page content component'
        },
        {
            key: 'DcPageHierarchyTreeComponent',
            component: DcPageHierarchyTreeComponent,
            selector: 'dc-page-hierarchy-tree',
            type: 'Component',
            label: 'dc page hierarchy tree component'
        },
        {
            key: 'DcPageSearchComponent',
            component: DcPageSearchComponent,
            selector: 'dc-page-search',
            type: 'Component',
            label: 'dc page search component'
        },
        {
            key: 'DcConfigPage',
            component: DcDocsPage,
            selector: 'dc-config-page',
            type: 'PageComponent',
            label: 'dc config page'
        }
    ]
}

export const DC_TEST_PROVIDERS: Provider[] = [
    {provide: TEST_MODULE_REGISTRY, useValue: dcModuleEntry, multi: true}
];